import AnimationFactory from "../../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationFactory";
import AnimationOptions from "../../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationOptions";
import FadeToColorOptions from "../../../../../lib/html5-software-library/src/ranj/ui/animation/transition-animations/FadeToColorOptions";
import { isUndefined } from "../../../../../lib/html5-software-library/src/ranj/util/TypeUtil";
import { getURLParameter } from "../../../../../lib/html5-software-library/src/ranj/util/URLUtil";
import TrackString from '../../../analytics/TrackString';
import MapModel from "../../../app/map/model/MapModel";
import MapsConfig from "../../../app/map/model/MapsConfig";
import AbstractCommand from "../../../core/application/AbstractCommand";
import ContextEvent from '../../../core/application/ContextEvent';
import AssetLoadServiceEvent from "../../../core/assetloading/events/AssetLoadServiceEvent";
import SkinKeyRegistry from "../../../core/ui/SkinKeyRegistry";
import LaptopDestroyEvent from "../../laptop/model/LaptopDestroyEvent";
import LaptopSetupEvent from "../../laptop/model/LaptopSetupEvent";
import SmartphoneDestroyEvent from "../../smartphone/model/SmartphoneDestroyEvent";
import SmartphoneSetupEvent from "../../smartphone/model/SmartphoneSetupEvent";
import ScenarioPlayerEvent from "../ScenarioPlayerEvent";
import ScenarioPlayerRegisterEvent from "./ScenarioPlayerRegisterEvent";
import NGTConfigKey from "../../base/NGTConfigKey";
import SaveGameEvent from "../../../app/save-game/events/SaveGameEvent";
import StoryFrameworkPlayerMemento from "../../../../../lib/html5-software-library/src/ranj/eng/story/framework/player/StoryFrameworkPlayerMemento";
import SaveGameModel from "../../../app/save-game/model/SaveGameModel";
import TrackScreenString from "../../../analytics/TrackScreenString";
/**
* PlayScenarioCommand.js
* 
* Created on 2-okt-2013, 16:08:55
*
* @author Ivo Swartjes for Ranj
**/
export default class PlayScenarioCommand extends AbstractCommand {
    
    constructor(injector, storyFactory, languagePack, stageManager, playSessionModel, soundManager,
        scenarioLibrary, dispatcher, assetLoadService, assetLocator, revisionToolGateway, variableManager, assetLibrary, mapsConfig, mapModel, config, saveGameModel, saveGameService, fileModel, scenarioPlayer) {

        super(dispatcher);

        this._scenarioPlayer = scenarioPlayer;
        this._scenarioToPlay;
        this._storyFactory = storyFactory;
        this._playSessionModel = playSessionModel;
        this._scenarioLibrary = scenarioLibrary;
        this._assetLocator = assetLocator;
        this._dispatcher = dispatcher;
        this._injector = injector;
        this._assetLoadService = assetLoadService;
        this._revisionToolGateway = revisionToolGateway;
        this._variableManager = variableManager;
        this._assetLibrary = assetLibrary;
        this._languagePack = languagePack;
        this._stageManager = stageManager;
        this._soundManager = soundManager;
        this._config = config;
        /** @type {SaveGameModel} */
        this._saveGameModel = saveGameModel;
        this._saveGameService = saveGameService;
        this._fileModel = fileModel;
        this._npcModel = null;

        /** @type {MapsConfig} */
        this._mapsConfig = mapsConfig;
        /** @type {MapModel} */
        this._mapModel = mapModel;

        this._onScenarioLoaded = this.onScenarioLoaded.bind(this);
        this._onScenarioEnd = this.onScenarioEnd.bind(this);

        this.execute = function (event) {

            console.info("Play scenario command");

            // Decide which scenario to play
            if (isUndefined(event.params) || isUndefined(event.params.scenario)) {
                this._scenarioToPlay = this._scenarioLibrary.getDefaultScenario();
            } else {
                this._scenarioToPlay = event.params.scenario;
            }

            //Process '?chapter=' parameter or savegame (ProgressGameModel) and map to asset groups
            // TODO: process savegame here as well
            // Check url parameter to see which arc to start:
            this.startChapter = this.determineStartChapter();
            const assetGroupsForChapter = this._config.getValue(NGTConfigKey.SCENARIOS)[0].chapterToAssetsMapping[this.startChapter];


            // Open loading screen
            this._loadingPopupSkin = this.openPopup(SkinKeyRegistry.LOADING_SCREEN_SKIN, null, {
                needsOverlay: false,
                animationType: AnimationFactory.FADE_TO_COLOR_IN,
                animationOptions: new FadeToColorOptions('#000', .5, 0, 1050, createjs.Ease.sineInOut),
            });

            // Load scenario assets
            dispatcher.addEventListener(AssetLoadServiceEvent.LOAD_COMPLETE, this._onScenarioLoaded);
            this._assetLoadService.loadGroups(this._scenarioToPlay.id, ...assetGroupsForChapter);
            //also add to assetLocator (so DialogEditorGateway can find assets)
            this._assetLocator.addManifest(this._assetLoadService.getManifest(this._scenarioToPlay.id));

            var lazyLoadAssetManifest = this._assetLoadService.getManifest(this._scenarioToPlay.id + "_lazyLoad");
            this._assetLocator.addManifest(lazyLoadAssetManifest);
        }
    }

    determineStartChapter() {
        let chapter = getURLParameter("chapter");
        const chapterToArcMapping= this._config.getValue(NGTConfigKey.SCENARIOS)[0].chapterToArcMapping;
        const validStartChapters = Object.keys(chapterToArcMapping);
        if (!validStartChapters.includes(chapter)) {
            chapter = validStartChapters[0];
        }
        //Overwrite if savegame:
        if (this._saveGameService.saveGameExists()) {
            chapter = this._saveGameModel.progress.chapter;
        }
        return chapter;
    }

    onScenarioLoaded(event) {
        this._dispatcher.removeEventListener(AssetLoadServiceEvent.LOAD_COMPLETE, this._onScenarioLoaded);

        // Close loading screen
        this.closePopup(this._loadingPopupSkin, {
            animationType: AnimationFactory.FADE_TO_COLOR_OUT,
            animationOptions: new FadeToColorOptions('#000', .5, 0, 1050, createjs.Ease.sineInOut),
        });
        this._loadingPopupSkin = null;

        // Set the current scenario in the library
        this._scenarioLibrary.setCurrentScenario(this._scenarioToPlay);

        // Start a new scenario play session
        this._playSessionModel.startNewScenarioSession(this._scenarioToPlay.id);

        // Analytics: set scenario id as persistent value so all events during scenario are attributed accordingly
        // NB: value is unset when dialog closes/completes
        this.trackPersistentValue(TrackString.PERSISTENT_STORY_ID, this._scenarioToPlay.id);
        this.trackEvent(TrackString.EVENT_SCENARIO_START);

        // 20230525, RF: Don't create a new scenario player. It is now a singleton and injected in constructor.
        //	NB: scenarioPlayer is not a singleton
        //  this._scenarioPlayer = this._injector.getValue('scenarioPlayer');

        // Create story
        this._scenarioToPlay.story = this._storyFactory.getStory(this._scenarioToPlay.storyID);

        // Initialize scenario 
        // TODO: from story memento, if any; else start with clear variable manager
        this._variableManager.reset();
        this._scenarioPlayer.init(this._scenarioToPlay, null);        

        var sprEvent = new ScenarioPlayerRegisterEvent(ScenarioPlayerRegisterEvent.REGISTER, this._scenarioPlayer);
        this._dispatcher.dispatch(sprEvent.type, sprEvent);

        // Set up smartphone
        var smartphoneSetupEvent = new SmartphoneSetupEvent(SmartphoneSetupEvent.PERFORM);
        this._dispatcher.dispatch(smartphoneSetupEvent.type, smartphoneSetupEvent);

        // Set up laptop
        var laptopSetupEvent = new LaptopSetupEvent(LaptopSetupEvent.PERFORM);
        this._dispatcher.dispatch(laptopSetupEvent.type, laptopSetupEvent);

        // Start the scenario!
        this._startTime = Date.now();
        this._scenarioPlayer.eventDispatcher.addEventListener(ScenarioPlayerEvent.SCENARIO_END, this._onScenarioEnd);
        
        if (this._saveGameService.saveGameExists()) {
            //TODO: THIS IS TAKEN 1:1 from Ready1, so needs to be checked if all this works in the new game as well

            // Restore story variables and memento
            this._variableManager.setState(this._saveGameModel.variables);

            if (this._saveGameModel.gameFinished) {
                return; // this is handled by LoadGameCommand, so this case shouldnt occur?
            }

            // TEMP: Load files here as we need the story LP to be initialized
            this._fileModel.fromObject(this._saveGameModel.files, this._languagePack);

            const memento = new StoryFrameworkPlayerMemento();
            memento.deserialize(this._saveGameModel.story);
            this._scenarioPlayer.getStoryPlayer().load(memento);

            this._scenarioPlayer.play();

            // Trigger story node available handle again to kick-start the engine
            const availableStoryNodes = this._scenarioPlayer.getStoryPlayer().availableStoryNodes().array;
            for (let i = 0; i < availableStoryNodes.length; i++) {
                const availableStoryNode = availableStoryNodes[i];
                console.log('[PlayScenarioCommand] Restoring available story node', availableStoryNode);
                this._scenarioPlayer.handleStoryNodeAvailable({
                    data: {
                        storyNode: availableStoryNode
                    }
                });
            }
        } else {
            // Set correct variable to start specified chapter/arc if using url parameter:
            const chapterToArcMapping= this._config.getValue(NGTConfigKey.SCENARIOS)[0].chapterToArcMapping;
            const startArc = chapterToArcMapping[this.startChapter];
            const variableName = "start_arc_" + startArc;
            this._variableManager.setVariable(variableName, true);

            this._scenarioPlayer.play();
        }

        // Init map model with map for current chapter.
        //const firstMap = this._mapsConfig.maps[this.startChapter - 1]; // NB: startChapter starts at 1 (for "chapter_1"), so -1
        const map = this._mapsConfig.getMapByChapterWeek(this.startChapter, this._saveGameModel.progress.week);
        this._mapModel.setCurrentMap(map);

        //this._mapModel.setCurrentMap(firstMap);

        // Show hub
        this.openScreen(SkinKeyRegistry.HUB_SCREEN_SKIN);
    }

    onScenarioEnd(event) {
        var sprEvent = new ScenarioPlayerRegisterEvent(ScenarioPlayerRegisterEvent.DEREGISTER, this._scenarioPlayer);
        this._dispatcher.dispatch(sprEvent.type, sprEvent);

        // Analytics: tracks scenario end
        const duration = Date.now() - this._startTime;
        this.trackEvent(TrackString.EVENT_SCENARIO_END, TrackString.createScenarioEndParams(duration));

        try {
            const playtime = new Date() - new Date(this._saveGameModel.gameStart);
            this.trackEvent(TrackString.EVENT_GAME_END, {
                playtime,
            });
        } catch (e) {
            this.trackEvent(TrackString.EVENT_GAME_END);
        }

        // Analytics: unset scenario id from persistent value 
        this.trackPersistentValue(TrackString.PERSISTENT_STORY_ID, null);

        this._dispatcher.removeEventListener(AssetLoadServiceEvent.LOAD_COMPLETE, this._onScenarioLoaded);
        this._scenarioPlayer.eventDispatcher.removeEventListener(ScenarioPlayerEvent.SCENARIO_END, this._onScenarioEnd);
        this._scenarioPlayer.stop();
        this._scenarioPlayer = null;

        this._injector = null;
        this._scenarioToPlay = null;
        this._storyFactory = null;
        this._playSessionModel = null;
        this._revisionToolGateway = null;

        this._onScenarioLoaded = null;
        this._onScenarioEnd = null;

        // Destroy Smartphone
        this._dispatcher.dispatch(SmartphoneDestroyEvent.PERFORM);

        // Destroy Laptop
        this._dispatcher.dispatch(LaptopDestroyEvent.PERFORM);

        // Save the game
        //const saveGameEvent = new SaveGameEvent(SaveGameEvent.SAVE_GAME, { gameFinished: true });
        //this.dispatch(saveGameEvent.type, { data: saveGameEvent });

        //this._saveGameService.clear();

        this.trackEvent(TrackString.EVENT_SCREEN_STARTED, {screen_started: TrackScreenString.CREDIT_SCREEN});

        // Go to end screen
        this.closeScreen(SkinKeyRegistry.HUB_SCREEN_SKIN);
        this.openScreen(SkinKeyRegistry.END_SCREEN_SKIN, {
            animationType: AnimationFactory.FADE_IN,
            animationOptions: new AnimationOptions(0, 450, createjs.Ease.sineInOut),
        });
    }
}